<template>
    <div>
        <section v-if="user" class="mb-4">
            <b-field label="Фамилия">
                <b-input disabled :value="user.lastName"></b-input>
            </b-field>
            <b-field label="Имя">
                <b-input disabled :value="user.firstName"></b-input>
            </b-field>
            <b-field label="Отчество">
                <b-input disabled :value="user.surName"></b-input>
            </b-field>

        </section>

        <section v-if="userRoles.length && organization">
            <b-field label="ЦПО">
                <div>
                    {{organization.parentPath()}}
                </div>
            </b-field>
            <b-field label="Роль">
                <div>
                    {{roleNamesByUserRoles(userRoles)}}
                </div>
            </b-field>

            <b-field label="Основная Должность" :class="{'multiselect-error': hasError('mainPosition')}" :type="type('mainPosition')" :message="error('mainPosition')">
                <multiselect :allow-empty="false" v-model="formData.mainPosition" :options="positionList" label="name" trackBy="id" placeholder="Должность" >
                    <template #option="props">
                        <span :title="$_get(props.option, 'fullname')">{{ props.option.name }}</span>
                    </template>
                    <template #noResult="props">
                        Не найдено ничего
                    </template>
                    <template #noOptions="props">
                        Пусто
                    </template>
                </multiselect>
            </b-field>
            <b-field :disabled="!formData.mainPosition" label="Дополнительные Должности">
                <multiselect :allow-empty="true" :disabled="!formData.mainPosition" multiple v-model="formData.additionalPositions" :options="positionList" label="name" trackBy="id" placeholder="Должности" >
                    <template #option="props">
                        <span :title="$_get(props.option, 'fullname')">{{ props.option.name }}</span>
                    </template>
                    <template #noResult="props">
                        Не найдено ничего
                    </template>
                    <template #noOptions="props">
                        Пусто
                    </template>
                </multiselect>
            </b-field>
            <b-field label="Группа">
                <multiselect :allow-empty="false" v-model="formData.group" :options="groupList" label="name" trackBy="id" placeholder="Группа" >
                    <template #noResult="props">
                        Не найдено ничего
                    </template>
                    <template #noOptions="props">
                        Пусто
                    </template>
                </multiselect>
            </b-field>
            <b-field v-if="applicationHasOnlyStudentRole && organization" label="Табельный номер" :type="type('tablenumber')" :message="error('tablenumber')">
                <table-number :code="organization.parentCode" v-model="formData.tablenumber"  />
            </b-field>
        </section>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { reduce, get, find, map, uniq, filter, each } from 'lodash'
import { NULL_UID } from '../../../../constants'
import { STATUS_APPROVED, STUDENT } from '../../../../store/models/roles/model'
import HasErrors from '../../../../mixins/HasErrors'
import ApplicationMixin from '../../../../mixins/ApplicationMixin'
import UserRolesMixin from '../../../../mixins/UserRolesMixin'
import OrganizationFetchMixin from '../../../../mixins/OrganizationFetchMixin'

export default {
    props: {
        userId: String,
    },
    mixins: [
        HasErrors,
        ApplicationMixin,
        UserRolesMixin,
        OrganizationFetchMixin,
    ],
    mounted () {
        this.fetchOrganizationsIfNeeded()
        this.fetchRoles()
        this.fetchPositions()
        this.fetchApplications({
            userId: this.userId
        })
    },
    computed: {
        ...mapGetters({
            currentUser: 'e/users/currentUser',
            currentUserId: 'e/users/currentUserId',
            userQuery: 'e/users/query',
            currentOrganizationId: 'e/users/currentOrganizationId',
            organizationQuery: 'e/organizations/query',
            applicationQuery: 'e/applications/query',
            positionQuery: 'e/positions/query',
            roleQuery: 'e/roles/query',
            isLoaderActive: 'e/pages/isLoaderActive',
            applicationById: 'e/applications/applicationById',
            groupQuery: 'e/groups/query',
        }),

        applications() {
            return this.applicationQuery().where('userId', this.userId).where('status', STATUS_APPROVED).where((item) => {
                return get(item, 'userRolePivot.0.organization.id', null) === this.organizationId
            }).get()
        },
        organizationApplications() {
            return this.applicationQuery().where('userId', this.userId).where('status', STATUS_APPROVED).where((item) => {
                return filter(get(item, 'userRolePivot', []), userRole => {
                    return get(userRole, 'organization.id') === this.organizationId
                }).length > 0
            }).get()

        },

        isLoading() {
            return this.isLoaderActive('users.fetchById')
        },
        user() {
            return this.userQuery().with(['userRolePivot.role', 'userRolePivot.group', 'userRolePivot.position', 'userRolePivot.organization']).find(this.userId)
        },
        userRoles() {
            let userRoles = []
            each(this.organizationApplications, item => {
                let items = get(item, 'userRolePivot', [])
                each(items, userRole => {
                    userRoles.push(userRole)
                })
            })
            return userRoles
        },
        organizationId() {
            return this.currentOrganizationId
        },
        organization() {
            return this.organizationQuery().find(this.organizationId)
        },
        groupList() {
            let groupQuery = this.groupQuery().whereHasNot('children')
            groupQuery = groupQuery.where('cpoId', this.organizationId)
            return reduce(
                groupQuery.get(),
                (result, item) => {
                    result.push(item)
                    return result
                },
                [{id: NULL_UID, 'name': 'Без группы'}]
            )
        },
        positionList() {
            let query = this.positionQuery().orderBy('name').where('parentId', value => !!value)
            return reduce(
                query.get(),
                (result, item) => {
                    result.push(item)
                    return result
                },
                []
            )
        },
        applicationHasOnlyStudentRole() {
            let roleList = uniq(map(this.userRoles, 'role.sysname'))
            return roleList.length === 1 && get(roleList, '0') === STUDENT
        },
    },
    methods: {
        ...mapActions({
            fetchRoles: 'e/roles/fetchItems',
            fetchGroups: 'e/groups/fetchItems',
            fetchOrganizations: 'e/organizations/fetchItems',
            fetchApplication: 'e/applications/fetchById',
            fetchApplications: 'e/applications/fetchItems',
            fetchUser: 'e/users/fetchById',
            fetchPositions: 'e/positions/fetchItems',
            saveApplication: 'e/applications/save',
        }),

        fillStudentApplication () {
            this.fillFormFromUserRoles(this.userRoles)
        },
        fillFormFromUserRoles(userRoles) {
            this.formData.additionalPositions = []
            for (let i in userRoles) {
                let userRole = userRoles[i]
                if (userRole.isMain && get(userRole, 'role.sysname') === STUDENT && get(userRole, 'position.id') !== null) {
                    this.formData.mainPosition = find(this.positionList, item => item.id === get(userRole, 'position.id'))
                }
                if (!userRole.isMain && get(userRole, 'position.id') !== null && !find(this.formData.additionalPositions, {id: get(userRole, 'position.id')})) {
                    this.formData.additionalPositions.push(find(this.positionList, item => item.id === get(userRole, 'position.id')))
                }
                if (userRole.isMain && get(userRole, 'role.sysname') === STUDENT && get(userRole, 'group.id') !== null) {
                    this.formData.group = find(this.groupList, item => item.id === get(userRole, 'group.id'))
                }
            }

            for (let i in userRoles) {
                let userRole = userRoles[i]
                if (userRole.isMain && !this.formData.mainPosition && get(userRole, 'position.id') !== null) {
                    this.formData.mainPosition = find(this.positionList, item => item.id === get(userRole, 'position.id'))
                }
                if (userRole.isMain && !this.formData.group && get(userRole, 'group.id') !== null) {
                    this.formData.group = find(this.groupList, item => item.id === get(userRole, 'group.id'))
                }
            }
        },

        fillForm() {
            this.formData.tablenumber = get(this.user, 'tablenumber', '')
        },

        save() {
            if (this.applicationHasOnlyStudentRole && !this.formData.mainPosition) {
                this.setError('mainPosition', 'Должность не выбрана')
                return Promise.reject('Должность не выбрана')
            }
            if (this.applicationHasOnlyStudentRole && !this.formData.tablenumber) {
                this.setError('tablenumber', 'Табельный номер пуст')
                return Promise.reject('Табельный номер пуст')
            }
            if (!this.organizationApplications) {
                this.setError('message', 'Ошибка, отсутствует заявка студента. Обратитесь к администратору')
                return Promise.reject()
            }

            this.$emit('processing', true)

            let userRoles = []

            let mainRoles = filter(this.userRoles, item => item.isMain)

            each(mainRoles, userRole => {
                let param = {
                    id: userRole.id,
                    isMain: true,
                    role: {
                        id: userRole.role.id
                    },
                    position: {
                        id: this.formData.mainPosition.id
                    },
                    organization: {
                        id: userRole.organization.id
                    }
                }

                if (this.formData.group && this.formData.group.id !== NULL_UID) {
                    param.group = {
                        id: this.formData.group.id
                    }
                }

                userRoles.push(param)

                each(this.formData.additionalPositions, addUserRole => {
                    let param = {
                        isMain: false,
                        role: {
                            id: userRole.role.id
                        },
                        organization: {
                            id: userRole.organization.id
                        },
                        position: {
                            id: addUserRole.id
                        },
                    }
                    if (this.formData.group && this.formData.group.id !== NULL_UID) {
                        param.group = {
                            id: this.formData.group.id
                        }
                    }

                    userRoles.push(param)
                })
            })



            if (userRoles.length === 0) {
                return Promise.reject('Ошибка, Список мета ролей пуст. Обратитесь к администратору.')
            }

            let promises = []
            each(this.organizationApplications, application => {
                let param = {
                    id: get(application, 'id'),
                    user: {
                        id: get(application, 'userId'),
                        tablenumber: this.formData.tablenumber
                    },
                    status: get(application, 'status'),
                    userRolePivot: userRoles
                }
                promises.push(this.wrapAction(this.saveApplication(param)))
            })

            return Promise.all(promises)
            .then(()=>{
                this.fetchUser(this.userId)
            })
            .finally(() => {
                this.$emit('processing', false)
            })
        },

        reject() {

        }
    },
    data () {
        return {
            STUDENT,
            formData: {
                group: null,
                tablenumber: '',
                mainPosition: null,
                additionalPositions: [],
            }
        }
    },
    watch: {
        formData: {
            deep: true,
            handler() {
                this.resetErrors()
            }
        },
        organizationApplications: {
            immediate: true,
            deep: true,
            handler() {
                if (this.organizationApplications.length !== 0) {
                   this.fillStudentApplication()
                }
            }
        },
        userId: {
            immediate: true,
            handler() {
                if (this.userId) {
                    this.fetchUser(this.userId).then(()=> {})
                }
            }
        },
        user: {
            immediate: true,
            handler() {
                this.fillForm()
                this.fillStudentApplication()
            }
        },
    }
}
</script>